import { createContext, useContext } from 'react';
import type { ImpersonatedPractice } from './ImpersonationContext';

interface ImpersonationContextValue {
  impersonatedPractice: ImpersonatedPractice | null;
  startImpersonation: (practice: ImpersonatedPractice) => void;
  stopImpersonation: () => void;
}

export const ImpersonationContext = createContext<ImpersonationContextValue>({
  impersonatedPractice: null,
  startImpersonation: () => {},
  stopImpersonation: () => {},
});

export function useImpersonation() {
  return useContext(ImpersonationContext);
}
